/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Loading/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Heading from './Heading/index'
import LoadingBar from 'DesignSystem/LoadingBar/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Loading({
  children,
  viewPath = "/App/Account/NewPatient/Content/Panes/Lead/Loading"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<Heading
  viewPath={`${viewPath}/Heading`}
/>
<div
  data-testid="Loading.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<LoadingBar
  viewPath={`${viewPath}/LoadingBar`}
 borderBottomLeftRadius={8}
 borderBottomRightRadius={8}
 borderTopLeftRadius={8}
 borderTopRightRadius={8}
 height={dtSpaceS}
 width={200}
/>
</div>
{children}
</React.Fragment>)
}